import { SvgIcon, SvgIconProps } from "@mui/material";

export const SparklesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width="27" height="24" viewBox="0 0 27 24" {...props}>
      <path d="M26.9998 13.211L26.8459 13.2504C22.7437 14.3022 19.5735 17.5589 18.6328 21.6881C17.4808 17.5283 14.1922 14.3023 10.0111 13.2304L9.93555 13.211C14.1606 12.1278 17.4861 8.83215 18.6328 4.62384C19.573 8.81815 22.836 12.1435 26.9998 13.211Z" />
      <path d="M12.0278 5.4293L11.968 5.45807C9.67559 6.56194 7.85723 8.45433 6.84567 10.789C5.70274 8.45552 3.80005 6.55658 1.45898 5.4293C3.79848 4.30277 5.68546 2.4143 6.81015 0.0739168L6.84567 0C7.85656 2.37797 9.69972 4.30827 12.0278 5.4293Z" />
      <path d="M4.40604 15.4763L4.40215 15.4128L4.39432 15.4892C4.16404 17.7357 2.38483 19.51 0.137695 19.7341C2.38558 19.9583 4.16854 21.7531 4.40215 24C4.54112 21.7672 6.27861 19.9561 8.50467 19.7341C6.27907 19.5122 4.54304 17.7087 4.40604 15.4763Z" />
    </SvgIcon>
  );
};
